import React from 'react';
import { ImageWrapper } from './styles';
import LazyLoad from 'react-lazyload';

interface IProps {
  src?: string;
  aspectRatio: number;
  alt?: string;
  srcSet?: string;
  webp?: string;
  className?: string;
  bg?: string;
  onClick?: any;
  lazy?: boolean;
  secondaryRatio?: number;
}

const OImage = ({
  src,
  aspectRatio,
  alt,
  srcSet,
  webp,
  className,
  bg,
  onClick,
  lazy = true,
  secondaryRatio
}: IProps) => {
  const sizes = `(-webkit-min-device-pixel-ratio: 2) 50vw,
  (min-resolution: 192dpi) 50vw,
  (min-resolution: 2dppx) 50vw,
  (-webkit-min-device-pixel-ratio: 3) 33.33vw,
  (min-resolution: 288dpi) 33.33vw,
  (min-resolution: 3dppx) 33.33vw`;

  return lazy ? (
    <ImageWrapper
      as={LazyLoad}
      height={'100%'}
      once
      offset={100}
      ratio={aspectRatio}
      secondaryRatio={secondaryRatio}
      bg={bg}
      className={`${className ? className : 'image'}`}>
      {bg && bg !== '' ? (
        <div className={'bg'} onClick={onClick} />
      ) : (
        <picture>
          <source type="image/webp" srcSet={webp} sizes={sizes} />
          <source type="image/png" srcSet={srcSet} sizes={sizes} />
          <img src={src} sizes={sizes} alt={alt || ''} onClick={onClick} />
        </picture>
      )}
    </ImageWrapper>
  ) : (
    <ImageWrapper
      ratio={aspectRatio}
      secondaryRatio={secondaryRatio}
      bg={bg}
      className={`${className ? className : 'image'}`}
      onClick={onClick}>
      {bg && bg !== '' ? (
        <div className={'bg'} />
      ) : (
        <picture>
          <source type="image/webp" srcSet={webp} sizes={sizes} />
          <source type="image/png" srcSet={srcSet} sizes={sizes} />
          <img src={src} sizes={sizes} alt={alt || ''} />
        </picture>
      )}
    </ImageWrapper>
  );
};

export default OImage;
